import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import TopFooter from './TopFooter/TopFooter';
import BottomFooter from './BottomFooter/BottomFooter';
import { loadPages } from '../../../redux/modules/pages';

import './Footer.scss';

const Footer = props => {
  const {
    siteName,
    datiFarmacia,
    logoImage,
    isCheckout,
    primaryColor,
    showDiscountsLinkInFooter,
    discounted,
    pages,
    hasFidelityCard,
    footerTextField,
    isMobile,
  } = props;

  useEffect(() => {
    props.loadPages();
  }, []);

  return (
    <footer>
      <TopFooter
        isMobile={isMobile}
        isCheckout={isCheckout}
        datiFarmacia={datiFarmacia}
        footerTextField={footerTextField}
        logoImage={logoImage}
        siteName={siteName}
        primaryColor={primaryColor}
        showDiscountsLinkInFooter={showDiscountsLinkInFooter}
        discounted={discounted}
        pages={pages}
        hasFidelityCard={hasFidelityCard}
      />
      <BottomFooter primaryColor={primaryColor} datiFarmacia={datiFarmacia} />
    </footer>
  );
};

const mapStateToProps = state => ({
  isMobile: state.layout.isMobile,
  siteName: state.store.data.datiFarmacia.siteName,
  datiFarmacia: state.store.data.datiFarmacia,
  discounted: state.homeProducts.data.discounted,
  logoImage:
    state.store.data.loghiTemplate.logoFooterImage ||
    state.store.data.loghiTemplate.logoImage,
  primaryColor: state.store.data.loghiTemplate.brandColor,
  showDiscountsLinkInFooter:
    state.store.data.loghiTemplate.showDiscountsLinkInFooter,
  feedaty: {
    enabled: state.store.data.features.hasFeedaty,
    widgetId: state.store.data.integrazioni.feedaty.widgetId,
    siteKey: state.store.data.integrazioni.feedaty.siteKey,
  },
  pages: state.pages.data,
  hasFidelityCard: state.store.data.features.hasFidelityCard,
  footerTextField: state.store.data.funzionalita.footerTextField,
});

export default connect(mapStateToProps, { loadPages })(Footer);
